import * as TFF from '@tff/types/tff';
import { NDC_AND_NDCX_BOOKING_SOURCES, NDC_AND_NDCX_TFF_BOOKING_SOURCES } from '../constants/booking-sources';

export const isNdcFlightOnlyBooking = (retrieveItem?: TFF.Retrieve): boolean => {
  return (
    !!retrieveItem?.bookingSource &&
    NDC_AND_NDCX_BOOKING_SOURCES.includes(retrieveItem.bookingSource) &&
    retrieveItem.product !== 'atcomres' &&
    retrieveItem.product !== 'atcomnr'
  );
};

const CONSOLIDATOR_PROMO_GROUP = 'CONSOLIDATOR';

export const isTTSBooking = (retrieveItem?: TFF.Retrieve): boolean => {
  return (
    (retrieveItem?.status === 'BOOKED' || retrieveItem?.status === 'CANCELLED') &&
    retrieveItem?.additionalParams?.promoGroup?.toUpperCase() === CONSOLIDATOR_PROMO_GROUP
  );
};

export const isNdcBooking = (retrieveItem?: TFF.Retrieve): boolean => {
  return !!retrieveItem?.bookingSource && ['AF', 'KL'].includes(retrieveItem.bookingSource);
};

export const isNskBookingSource = (bookingSource: TFF.TffBookingSource): boolean => {
  return (['TUI-NSK'] as TFF.TffBookingSource[]).includes(bookingSource);
};

export const isNdcOrNdcxBookingSource = (bookingSource: TFF.TffBookingSource): boolean => {
  return NDC_AND_NDCX_TFF_BOOKING_SOURCES.includes(bookingSource);
};

export const isNskBooking = (retrieveItem?: TFF.Retrieve): boolean => {
  return !!retrieveItem?.bookingSource && ['NSK'].includes(retrieveItem.bookingSource);
};

export const hasTariffType = (retrieveItem: TFF.Retrieve, tariffType: string): boolean => {
  return !!retrieveItem?.tariffType && retrieveItem?.tariffType?.toUpperCase() === tariffType.toUpperCase();
};

export const isAtcomresBooking = (retrieveItem?: TFF.Retrieve): boolean => {
  return retrieveItem?.product === 'atcomres';
};

